import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: 'close-button',
  template: `
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="close.emit()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
        [ngStyle]="{ width: size + 'px', height: size + 'px', fill: color }"
      >
          <path d="M28.79,0,14.74,13.92,1.21.52,0,1.72l13.53,13.4L.24,28.28l1.22,1.2L14.74,16.32,28.55,30l1.21-1.2L15.95,15.12,30,1.2Z" />
      </svg>
    </button>`,
})
export class CloseButtonComponent {
  @Input() size = 30;
  @Input() color = '#393b41';
  @Output() close = new EventEmitter<void>();
}
